// Router.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';

export const SocketContext = createContext();
const SOCKET_SERVER_URL = process.env.REACT_APP_API_URL_PROD; 
export const socketInstance = io(SOCKET_SERVER_URL);

export function useSocket() {
  return useContext(SocketContext);
}
